module.exports = __webpack_public_path__ + "img/arrow_green.3845edbb.svg";